/* 4Women — Filtro de la coleccion Vibes: por prenda y por color.
 *
 * Acompaña a `sections/fw-vibes-grid.liquid`, donde esta escrito el POR QUE de
 * la seccion entera. Aqui solo el comportamiento.
 *
 * ============================================================
 * DOS EJES QUE SE CRUZAN, Y NINGUNO PUEDE LLEVAR A LA NADA
 * ============================================================
 *
 * Gabriel: "que se pueda comprar por parte y por color porque en la coleccion
 * varias repiten prenda solo cambia el color".
 *
 * O sea que el cruce prenda x color no es un extra: es el uso principal. "Los
 * bra que hay en Merlot" es una pregunta de dos ejes, y con dos ejes libres se
 * llega facil a combinaciones vacias —hoy mismo, con 24 de los 32 productos en
 * borrador, "Abrigos + Black" no devuelve nada—.
 *
 * Por eso cada vez que se toca algo se recalcula el OTRO eje: cada chip muestra
 * cuantas prendas devolveria CON el filtro que ya esta puesto, y el que
 * devolveria cero se atenua.
 *
 * Se atenuan, no se esconden. Un chip que desaparece corre la fila entera bajo
 * el dedo y el siguiente toque cae sobre otra cosa.
 *
 * ============================================================
 * ATENUADO NO ES DESHABILITADO (09/09/2026, segunda vuelta)
 * ============================================================
 *
 * La primera version ponia `disabled` de verdad. Con cinco grupos por siete
 * colores eran 3 celdas vacias de 35 y casi nunca se tocaba una. Al pasar a
 * NUEVE tipos de prenda —pedido de Gabriel— son 63 celdas y solo 32 llenas: 31
 * vacias. Tocar un control apagado deja de ser el caso raro y pasa a ser el
 * gesto mas probable de la pagina.
 *
 * Y un boton `disabled` no responde a NADA: ni clic, ni foco, ni hover. La
 * clienta toca y no pasa absolutamente nada, que desde el otro lado de la
 * pantalla es indistinguible de una pagina rota.
 *
 * Ahora se atenuan pero siguen vivos: al tocar uno se elige ESE valor y se
 * suelta el del otro eje. "Estabas viendo Black, tocaste Shorts, no hay shorts
 * negros, aca tenes todos los shorts". Nunca hay callejon sin salida y nunca
 * hay un toque mudo. El cambio se cuenta en el pie de la barra.
 *
 * ============================================================
 * "TODO" LIMPIA LOS DOS EJES
 * ============================================================
 *
 * Antes el chip "Todo" solo soltaba la prenda y se quedaba con el color puesto:
 * la clienta tocaba el control de reset, seguia viendo tres tarjetas y se
 * llevaba la idea de que la coleccion entera son tres prendas. Un control que
 * dice "Todo" y no muestra todo miente. Ahora limpia los dos.
 *
 * ============================================================
 * LA ELECCION VIVE EN LA URL
 * ============================================================
 *
 * `?parte=tops&color=merlot`, con replaceState para no llenar el historial de
 * pasos intermedios. Esto es lo que permite mandar por WhatsApp "los tops en
 * merlot" y que del otro lado se abra filtrado, que en esta tienda es como se
 * vende de verdad. Se lee al cargar, asi que el enlace funciona en frio.
 *
 * ============================================================
 * TODO DELEGADO SOBRE DOCUMENT
 * ============================================================
 *
 * Igual que fw-packs.js y fw-abrigo-quickadd.js. El editor de temas repinta la
 * seccion por innerHTML y ahi un oyente puesto sobre un nodo concreto se pierde
 * con el nodo. Delegando, una sola carga sirve para siempre y para cualquier
 * cantidad de secciones en la pagina.
 */
(() => {
  if (window.__fwVibes) return;
  window.__fwVibes = true;

  const ver = (el) => el.getAttribute('data-parte') || '';
  const tono = (el) => el.getAttribute('data-color') || '';

  /* El estado no se guarda en una variable del modulo: se lee del DOM cada vez.
     Con el editor de temas repintando la seccion, una variable propia se queda
     apuntando a nodos que ya no estan.

     ============================================================
     POR QUE `sel-parte` Y NO `fw-parte`, QUE ERA LO OBVIO
     ============================================================

     La primera version guardaba el estado en `data-fw-parte` sobre la raiz, o
     sea CON EL MISMO NOMBRE que llevan los chips. Y los chips se buscan con
     `t.closest('.fw-vibes__chip[data-fw-parte]')`, que sube por los ancestros.

     Resultado: al tocar un circulo de color, `closest` no encontraba ningun
     chip de prenda en el camino... hasta llegar a `<fw-vibes>`, que llevaba el
     atributo porque ahi vivia el estado. El clic en el color entraba por la
     rama de la prenda y apagaba el filtro de prenda. Medido: elegir Black con
     Conjuntos puesto dejaba las 8 prendas y ningun filtro.

     No daba error, y con un solo eje puesto ni siquiera se notaba.

     Se arregla por los dos lados: el estado usa otro nombre Y los selectores
     de chip piden ademas la clase. Con cualquiera de los dos bastaba; van los
     dos porque el que viene detras solo va a ver uno. */
  const estado = (raiz) => ({
    parte: raiz.dataset.selParte || '',
    color: raiz.dataset.selColor || '',
  });

  const items = (raiz) => [].slice.call(raiz.querySelectorAll('.fw-vibes__item'));

  /* Cuenta cuantas prendas quedarian con ESTA combinacion. Es la funcion que
     usan a la vez el numero del chip y la decision de apagarlo, para que nunca
     puedan decir cosas distintas. */
  const cuantas = (lista, parte, color) =>
    lista.filter((it) => (!parte || ver(it) === parte) && (!color || tono(it) === color)).length;

  const pintar = (raiz) => {
    const { parte, color } = estado(raiz);
    const lista = items(raiz);

    let visibles = 0;
    lista.forEach((it) => {
      const entra = (!parte || ver(it) === parte) && (!color || tono(it) === color);
      it.hidden = !entra;
      if (entra) visibles += 1;
    });

    /* Chips de prenda: se cuentan contra el COLOR elegido, no contra el total. */
    raiz.querySelectorAll('.fw-vibes__chip[data-fw-parte]').forEach((b) => {
      const k = b.getAttribute('data-fw-parte');
      const n = cuantas(lista, k, color);
      const num = b.querySelector('.fw-vibes__n');
      if (num) num.textContent = String(n);
      const on = k === parte;
      const vacio = n === 0 && !on;
      /* `is-off` y `aria-disabled`, nunca `disabled`: ver la nota de la cabecera.
         Tiene que seguir recibiendo clic, foco y hover. */
      b.classList.toggle('is-off', vacio);
      b.setAttribute('aria-disabled', vacio ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    /* Tonos: al reves, se cuentan contra la PRENDA elegida. */
    raiz.querySelectorAll('.fw-vibes__tono[data-fw-color]').forEach((b) => {
      const k = b.getAttribute('data-fw-color');
      const n = cuantas(lista, parte, k);
      const on = k === color;
      const vacio = n === 0 && !on;
      b.classList.toggle('is-off', vacio);
      b.setAttribute('aria-disabled', vacio ? 'true' : 'false');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      /* La cuenta del tono va en la etiqueta accesible y no a la vista: debajo
         de la foto ya esta el nombre del color, y meterle ademas un numero
         convierte una caja de 64px en tres cosas. Quien usa lector de pantalla
         si la necesita, porque no ve que el swatch esta atenuado. */
      const nom = b.querySelector('.fw-vibes__tononom');
      if (nom) b.setAttribute('aria-label', nom.textContent.trim() + ', ' + n + ' prendas');
    });

    const vacio = raiz.querySelector('[data-fw-vibes-vacio]');
    if (vacio) vacio.hidden = visibles !== 0;

    const hayFiltro = !!(parte || color);
    const pie = raiz.querySelector('[data-fw-vibes-pie]');
    const aviso = raiz.querySelector('[data-fw-vibes-aviso]');
    /* El pie se ve si hay filtro puesto O si hay algo que contar. Oculto no
       ocupa alto, asi que quien no filtra nunca lo paga. */
    if (pie) pie.hidden = !hayFiltro && !(aviso && aviso.textContent);

    urlear(parte, color);
  };

  /* El aviso dura hasta el proximo gesto. No se borra con un temporizador
     —quien lee despacio se quedaria sin la explicacion— sino en cuanto la
     clienta vuelve a tocar algo, que es cuando deja de aplicar. */
  const avisar = (raiz, texto) => {
    const a = raiz.querySelector('[data-fw-vibes-aviso]');
    if (a) a.textContent = texto || '';
  };

  /* La etiqueta visible de un chip, sin su numero, para poder nombrarlo en el
     aviso con la misma palabra que la clienta acaba de tocar. */
  const rotulo = (b) => {
    if (!b) return '';
    const nom = b.querySelector('.fw-vibes__tononom');
    if (nom) return nom.textContent.trim();
    const copia = b.cloneNode(true);
    const num = copia.querySelector('.fw-vibes__n');
    if (num) num.remove();
    return copia.textContent.trim();
  };

  const urlear = (parte, color) => {
    if (!window.history || !history.replaceState) return;
    try {
      const u = new URL(window.location.href);
      if (parte) u.searchParams.set('parte', parte);
      else u.searchParams.delete('parte');
      if (color) u.searchParams.set('color', color);
      else u.searchParams.delete('color');
      history.replaceState(null, '', u.toString());
    } catch (e) {
      /* Una URL rara no puede tumbar el filtro. */
    }
  };

  /* ---------- Gestos ---------- */

  document.addEventListener('click', (ev) => {
    const t = ev.target instanceof Element ? ev.target : null;
    if (!t) return;

    const limpiar = t.closest('[data-fw-vibes-limpiar]');
    if (limpiar) {
      const raiz = limpiar.closest('fw-vibes');
      if (!raiz) return;
      raiz.dataset.selParte = '';
      raiz.dataset.selColor = '';
      avisar(raiz, '');
      pintar(raiz);
      return;
    }

    const chip = t.closest('.fw-vibes__chip[data-fw-parte]');
    if (chip) {
      const raiz = chip.closest('fw-vibes');
      if (!raiz) return;
      const k = chip.getAttribute('data-fw-parte');

      /* El chip "Todo" limpia LOS DOS ejes. Antes solo soltaba la prenda y se
         quedaba con el color: el control de reset mentia. */
      if (!k) {
        raiz.dataset.selParte = '';
        raiz.dataset.selColor = '';
        avisar(raiz, '');
        pintar(raiz);
        return;
      }

      if (chip.classList.contains('is-off')) {
        /* No hay nada en esta combinacion. Se elige la prenda y se suelta el
           color, en vez de no hacer nada. */
        const eraColor = rotulo(raiz.querySelector('.fw-vibes__tono[aria-pressed="true"]'));
        raiz.dataset.selParte = k;
        raiz.dataset.selColor = '';
        avisar(raiz, 'No hay ' + rotulo(chip) + ' en ' + (eraColor || 'ese color') + '. Te muestro todos.');
        pintar(raiz);
        return;
      }

      /* Volver a tocar el activo lo apaga. Es lo que espera cualquiera que haya
         usado un filtro de tienda, y ahorra ir a buscar el "Todo". */
      raiz.dataset.selParte = raiz.dataset.selParte === k ? '' : k;
      avisar(raiz, '');
      pintar(raiz);
      return;
    }

    const punto = t.closest('.fw-vibes__tono[data-fw-color]');
    if (punto) {
      const raiz = punto.closest('fw-vibes');
      if (!raiz) return;
      const k = punto.getAttribute('data-fw-color');

      if (punto.classList.contains('is-off')) {
        const eraParte = rotulo(raiz.querySelector('.fw-vibes__chip.is-on[data-fw-parte]'));
        raiz.dataset.selColor = k;
        raiz.dataset.selParte = '';
        avisar(raiz, 'No hay ' + (eraParte || 'esa prenda') + ' en ' + rotulo(punto) + '. Te muestro todo en ese color.');
        pintar(raiz);
        return;
      }

      raiz.dataset.selColor = raiz.dataset.selColor === k ? '' : k;
      avisar(raiz, '');
      pintar(raiz);
    }
  });

  /* ---------- Arranque ---------- */

  const arrancar = () => {
    document.querySelectorAll('fw-vibes').forEach((raiz) => {
      if (raiz.__fwListo) return;
      raiz.__fwListo = true;

      /* Se lee la URL, pero solo se acepta lo que existe de verdad en ESTA
         pagina. Un enlace guardado con `?color=olive` de cuando Olive estaba
         publicado no puede dejar la grilla en blanco: si el chip no esta, el
         valor se descarta y se ve todo. Esto es lo que hace que la pagina
         aguante el dia del lanzamiento, cuando la lista de chips cambia. */
      try {
        const q = new URLSearchParams(window.location.search);
        const p = q.get('parte') || '';
        const c = q.get('color') || '';
        if (p && raiz.querySelector('.fw-vibes__chip[data-fw-parte="' + CSS.escape(p) + '"]')) raiz.dataset.selParte = p;
        if (c && raiz.querySelector('.fw-vibes__tono[data-fw-color="' + CSS.escape(c) + '"]')) raiz.dataset.selColor = c;
      } catch (e) {
        /* Sin URL util se arranca sin filtro, que es el estado completo. */
      }

      pintar(raiz);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* El editor de temas repinta la seccion al tocar un ajuste: hay que volver a
     leerla. `shopify:section:load` es el evento que emite el propio editor. */
  document.addEventListener('shopify:section:load', arrancar);
})();
